import axios from 'axios'
import { Toast } from 'vant'
import { aiBaseURL } from '../utils/config'

// 创建独立axios实例（AI服务用不同域名）
const aiRequest = axios.create({
  baseURL: aiBaseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截：统一带token
aiRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截
aiRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Toast.fail(res.msg || 'AI服务异常')
      return Promise.reject(new Error(res.msg || 'error'))
    }
    return res
  },
  error => {
    if (error.response?.status === 401) {
      Toast.fail('请先登录')
    } else if (error.message?.includes('timeout')) {
      Toast.fail('AI回复超时，请稍后再试')
    } else {
      Toast.fail('AI客服暂时不可用')
    }
    return Promise.reject(error)
  }
)

// 发送消息
export function sendAiMessage(message) {
  return aiRequest({
    url: '/ai/chat',
    method: 'post',
    data: { message }
  })
}

// 获取历史对话
export function getAiHistory(page = 1, pageSize = 20) {
  return aiRequest({
    url: '/ai/history',
    method: 'get',
    params: { page, pageSize }
  })
}

// 清空对话
export function resetAiChat() {
  return aiRequest({
    url: '/ai/reset',
    method: 'post'
  })
}
